import {
  PayrollCalendarObject,
  PayrollCalendarParams,
} from '@/modules/employer/components/SetupEmployer/Features/PayrollCalendar/payrollCalendar.types';
import { storeCreator } from '@/utils/store/store.utils';

export type EditableCalendar = Partial<PayrollCalendarObject> & { config: PayrollCalendarParams };

interface State {
  editableCalendar?: EditableCalendar;
  handleSetEditableCalendar: (value?: EditableCalendar) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  editableCalendar: undefined,
  handleSetEditableCalendar: (value) =>
    set((state) => ({
      ...state,
      editableCalendar: value,
    })),
  handleReset: () =>
    set((state) => ({
      ...state,
      editableCalendar: undefined,
    })),
}));
